export interface IArticleI18n {
	readonly title: string;
	readonly locale: string;
	readonly content: string;
	readonly videoId: string;
	readonly pictureUrl: string;
}

export class ArticleI18n implements IArticleI18n {
	private _title: string;
	private _locale: string;
	private _content: string;
	private _videoId: string;
	private _pictureUrl: string;

	constructor(
		title: string,
		locale: string,
		content: string,
		videoId: string,
		pictureUrl: string
	) {
		this._title = title;
		this._locale = locale;
		this._content = content;
		this._videoId = videoId;
		this._pictureUrl = pictureUrl;
	}

	public get title(): string {
		return this._title;
	}

	public get locale(): string {
		return this._locale;
	}

	public get content(): string {
		return this._content;
	}

	public get videoId(): string {
		return this._videoId;
	}

	public get pictureUrl(): string {
		return this._pictureUrl;
	}
}
